import { ref, inject } from 'vue'
import { THEME_INJECTION_KEY } from '../../../tokens/index'

export function useTheme(colorPickerShow) {
  const color = ref(null)
  const { setCustormCssVar, primaryStyleVars, colorPrimary, getCustormThemeKey } =
    inject(THEME_INJECTION_KEY)

  //如果不支持自定义主题则清空以前缓存主题
  if (!colorPickerShow) {
    localStorage.removeItem(getCustormThemeKey())
  }

  color.value = primaryStyleVars.value['--color-primary']

  const colorChange = (val) => {
    color.value = val ?? colorPrimary.value
    setCustormCssVar({ '--color-primary': color.value })
  }
  return {
    color,
    colorChange,
  }
}
